export const StepIndicator = {
  flow: 'x',
  gap: 'Y',
  align: 'center center',
  width: '100%',
  padding: 'A 0',
  StepDot1: {
    flow: 'y', align: 'center center', flex: '1', gap: 'X',
    StepBar: { height: 'X', width: '100%', round: 'X', background: (el, s) => s.root.activeBookingStep >= 1 ? 'teal' : 'inkBorder' },
    StepLabel: { text: '{{ selectClinic | polyglot }}', fontSize: 'Y', color: (el, s) => s.root.activeBookingStep >= 1 ? 'teal' : 'inkMuted' }
  },
  StepDot2: {
    flow: 'y', align: 'center center', flex: '1', gap: 'X',
    StepBar: { height: 'X', width: '100%', round: 'X', background: (el, s) => s.root.activeBookingStep >= 2 ? 'teal' : 'inkBorder' },
    StepLabel: { text: '{{ selectService | polyglot }}', fontSize: 'Y', color: (el, s) => s.root.activeBookingStep >= 2 ? 'teal' : 'inkMuted' }
  },
  StepDot3: {
    flow: 'y', align: 'center center', flex: '1', gap: 'X',
    StepBar: { height: 'X', width: '100%', round: 'X', background: (el, s) => s.root.activeBookingStep >= 3 ? 'teal' : 'inkBorder' },
    StepLabel: { text: '{{ preCheck | polyglot }}', fontSize: 'Y', color: (el, s) => s.root.activeBookingStep >= 3 ? 'teal' : 'inkMuted' }
  },
  StepDot4: {
    flow: 'y', align: 'center center', flex: '1', gap: 'X',
    StepBar: { height: 'X', width: '100%', round: 'X', background: (el, s) => s.root.activeBookingStep >= 4 ? 'teal' : 'inkBorder' },
    StepLabel: { text: '{{ selectDate | polyglot }}', fontSize: 'Y', color: (el, s) => s.root.activeBookingStep >= 4 ? 'teal' : 'inkMuted' }
  },
  StepDot5: {
    flow: 'y', align: 'center center', flex: '1', gap: 'X',
    StepBar: { height: 'X', width: '100%', round: 'X', background: (el, s) => s.root.activeBookingStep >= 5 ? 'teal' : 'inkBorder' },
    StepLabel: { text: '{{ selectTime | polyglot }}', fontSize: 'Y', color: (el, s) => s.root.activeBookingStep >= 5 ? 'teal' : 'inkMuted' }
  },
  StepDot6: {
    flow: 'y', align: 'center center', flex: '1', gap: 'X',
    StepBar: { height: 'X', width: '100%', round: 'X', background: (el, s) => s.root.activeBookingStep >= 6 ? 'teal' : 'inkBorder' },
    StepLabel: { text: '{{ confirm | polyglot }}', fontSize: 'Y', color: (el, s) => s.root.activeBookingStep >= 6 ? 'teal' : 'inkMuted' }
  }
}
